import { BUSINESS_MODEL_ERROR, INDUSTRY_CATEGORY_ERROR } from './industryTagsHelper';

const NAME_ERROR = 'Name field is required.';
const ABBR_ERROR = 'Abbreviated name field is required.';
const USERS_ERROR = 'Users are required (at least one).';
const DESCRIPTION_ERROR = 'Description is required.';

export function createTradeShowErrorMessages(errors) {
  let errorsList = [];

  errorsList = errors.nameError ? errorsList.concat(NAME_ERROR) : errorsList;
  errorsList = errors.abbrError ? errorsList.concat(ABBR_ERROR) : errorsList;
  errorsList = errors.descriptionError ? errorsList.concat(DESCRIPTION_ERROR) : errorsList;
  errorsList = errors.industryCategoriesError ? errorsList.concat(INDUSTRY_CATEGORY_ERROR) : errorsList;
  errorsList = errors.businessModelsError ? errorsList.concat(BUSINESS_MODEL_ERROR) : errorsList;
  errorsList = errors.usersError ? errorsList.concat(USERS_ERROR) : errorsList;

  return errorsList;
}
